import Vue from 'vue'
import Router from 'vue-router'
import Home from './home'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/indexs'
    },
    {
      path: '/indexs',
      component: () => import('../login/indexs'),
      meta: {
        title: '首页',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/login',
      component: () => import('../login/login'),
      meta: {
        title: '登录',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/tiaoz',
      component: () => import('../login/tiaoz'),
      meta: {
        title: '消息中心',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/register',
      component: () => import('../login/register'),
      meta: {
        title: '注册',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/setpass',
      component: () => import('../login/setPass'),
      meta: {
        title: '找回密码',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/bindPhone',
      component: () => import('../login/bindPhone'),
      meta: {
        title: '找回密码',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/home',
      component: () => import('../views/Home'),
      children: Home,
    },
    {
      path: '/user',
      component: () => import('../views/user'),
      meta: {
        title: '账户管理',
        needLogin: true // 是否需要登录才能访问
      }
    },
    {
      path: '/accUp',
      component: () => import('../views/accUp'),
      meta: {
        title: '账号升级',
        needLogin: true // 是否需要登录才能访问
      }
    },
    {
      path: '/help',
      component: () => import('../views/help'),
      meta: {
        title: '帮助中心',
        needLogin: true // 是否需要登录才能访问
      }
    },
    {
      path: '/msg',
      component: () => import('../views/msg'),
      meta: {
        title: '消息中心',
        needLogin: true // 是否需要登录才能访问
      }
    },
    {
      path: '/file/editor',
      component: () => import('../views/children/editor'),
      meta: {
        title: '文件编辑',
        needLogin: true // 是否需要登录才能访问
      }
    },

  ]
})
// 设立跳转免验证路由
let noVerificationArr = ['/login', '/register','/setpass','/indexs','/tiaoz']
let _cookie = {
  _get: function (name) {
    let _cookie = document.cookie;
    let _start = _cookie.indexOf(name + "=");
    if (_start != -1) {
      _start += name.length + 1;
      let _end = _cookie.indexOf(";", _start);
      if (_end == -1) {
        _end = _cookie.length;
      }
      return unescape(_cookie.substring(_start, _end));
    }
    return "";
  }
};
// 设立导航守卫
router.beforeEach((to, from, next) => {
  // 目标正在前往强制跳转页，不需要拦截
  let rs = false
  noVerificationArr.map(item => {
    if (to.path === item) {
      next()
      rs = true
    }
  })
  if (rs) {
    return
  }
  // 因为导航守卫会比 created 更早触发，所以要先获取本地数据
  let userMid = _cookie._get('userMid')
  // 获取本地用户数据,当用户手动退出时，清空本地数据
  // 验证是否登录
  if (userMid === null || userMid === undefined || userMid === 'null') {
    console.log(111)
    next({
      path: '/login'
    })
  }
  next()
})

export default router